import { useMemo } from "react";
import { Highlighter } from "react-bootstrap-typeahead";
import { FormattedMessage, useIntl } from "react-intl";

import { useGetRateCardTemplates } from "api/queries/rate-card/useGetRateCardTemplates";
import SearchSelect from "pages/shipper/RequestForm/components/Common/SearchSelect";

type RateCardTemplateOption = {
  value: number;
  label: string;
  name: string;
  provider: string;
  freight_mode: string;
};

function DownloadTemplateRateCardFilter() {
  const intl = useIntl();
  const { data: templates = [], isLoading, isError } = useGetRateCardTemplates(true);

  const options: RateCardTemplateOption[] = useMemo(
    () =>
      templates.map((template) => ({
        value: template.id,
        label: template.name,
        name: template.name,
        provider: template.provider || "—",
        freight_mode: template.freight_mode || "—",
      })),
    [templates],
  );

  const handleRenderOption = ({ option, text }: { option: RateCardTemplateOption; text: string }) => (
    <div>
      <div className="font-weight-bold font-12">
        <Highlighter search={text}>{option.label}</Highlighter>
      </div>
      <div className="font-b3 font-weight-normal mt-1 text-secondary">
        <Highlighter search={text}>{option.provider}</Highlighter>
        {" · "}
        <Highlighter search={text}>{option.freight_mode}</Highlighter>
      </div>
    </div>
  );

  return (
    <div className="d-flex flex-wrap">
      <div className="w-192">
        <SearchSelect
          name="template_rate_card_id"
          preselect={false}
          shouldUnregister
          required
          disable={!options.length || isError}
          isLoading={isLoading}
          options={options}
          filterBy={["label", "name", "provider", "freight_mode"]}
          handleRenderOption={handleRenderOption}
          label={intl.formatMessage({
            id: "settings.fileImportTools.selectTemplate",
            defaultMessage: "Select Template",
          })}
          placeholder={intl.formatMessage({
            id: "settings.fileImportTools.dropdownPlaceholder",
            defaultMessage: "Choose an option...",
          })}
        />
        {!isLoading && !isError && !options.length && (
          <div className="font-b3 text-secondary mt-1">
            <FormattedMessage
              id="settings.fileImportTools.noRateCardTemplates"
              defaultMessage="No rate card templates available"
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default DownloadTemplateRateCardFilter;
